import React, { Component } from "react";
import FormPengembalian from "../Component/FormReturn_Com";
import SideBar from "../Component/Sidebar_Com";
import { close, generateToast } from "../Logic/toast_handler";
import ToastComp from "../Component/Toast_Com";
import { storage } from "../Logic/handler";
import { Button, Modal } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import ServerError from "./ServerError";
import ModalLoading from "../Component/ModalLoading";

class Pengembalian extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showToast: [],
      toastData: [],
      storageData: null,
      showModal: false,
      errorFetching: false,
      loading: false,
    };
    if (props.location.state) {
      this.transaction = props.location.state.transaction_id;
      this.company = props.location.state.company_id;
      this.storage = props.location.state.storage_origin;
    }
  }

  async componentDidMount() {
    this.setState({
      loading: true,
    });
    let res = await storage(localStorage.getItem("token"), null, "get");
    if (res[0] && res[0].status === 200) {
      this.setState({
        storageData: res[0].data,
        loading: false,
      });
    } else {
      if (res[1].status === 401) {
        this.props.history.push({
          pathname: "/",
          state: {
            code: -1,
            msg: "Token tidak valid, mohon melakukan log-in kembali.",
          },
        });
      } else {
        this.setState({
          loading: false,
          errorFetching: true,
        });
      }
      return;
    }
  }

  setCurrState = (data, afterFunc, paramFunc) => {
    this.setState(
      {
        ...data,
      },
      () => {
        if (afterFunc) {
          afterFunc(...paramFunc);
        }
      }
    );
  };

  showModal = (isShow) => {
    this.setState({
      showModal: true,
    });
  };

  render() {
    if (!this.props.location.state) {
      return <Redirect to={"/BadRequest"} />;
    }
    return (
      <div className="home">
        <SideBar />
        <div className="main">
          {this.state.loading && <ModalLoading />}
          {!this.state.errorFetching ? (
            this.state.storageData && (
              <FormPengembalian
                generateToast={generateToast}
                setParent={this.setCurrState}
                data={this.state.storageData}
                toast={[this.state.toastData, this.state.showToast]}
                showModal={this.showModal}
                sensitiveData={[this.transaction, this.company, this.storage]}
              />
            )
          ) : (
            <ServerError />
          )}
        </div>
        <div className="toast_container">
          {this.state.showToast.map((item, index) => {
            return (
              item && (
                <ToastComp
                  data={this.state.toastData[index]}
                  close={() =>
                    close(
                      this.state.toastData[index].idx,
                      this.state.toastData[index].pos,
                      [this.state.toastData, this.state.showToast],
                      this.setCurrState
                    )
                  }
                  isShow={this.state.showToast[index]}
                />
              )
            );
          })}
          <Modal
            show={this.state.showModal}
            onHide={() => this.props.history.push("/Storage")}
            backdrop="static"
          >
            <Modal.Header closeButton>
              <Modal.Title>Sukses!!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Data pengembalian telah berhasil disimpan</p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => this.props.history.push("/Storage")}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default Pengembalian;
